/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */


/**
 * @author: Kostiantyn Tsaregradskyi
 * @version: $Id$
 */


import _ from 'underscore';
import $ from 'jquery';
import Report from 'bi-report/src/bi/report/Report';
import HoverMenu from 'js-sdk/src/common/component/menu/HoverMenu';
import Notification from 'js-sdk/src/common/component/notification/Notification';
import LoadingDialog from 'js-sdk/src/common/component/dialog/LoadingDialog';
import WebPageView from 'js-sdk/src/common/component/webPageView/WebPageView';
import dashboardWiringStandardIds from '../../../enum/dashboardWiringStandardIds';
import dashboardSettings from '../../../dashboardSettings';
import hyperlinkTypes from 'bi-report/src/bi/report/jive/enum/hyperlinkTypes';
import sandboxFactory from '../../../factory/sandboxFactory';
import reportOutputFormats from 'bi-report/src/bi/report/enum/reportOutputFormats';
import browserDetection from 'js-sdk/src/common/util/browserDetection';
import menuContainerTemplate from '../../../template/menuContainerTemplate.htm';
import menuOptionTemplate from '../../../template/menuOptionTemplate.htm';
import jasperserverMessages from '../../../../i18n/jasperserver_messages.properties';
import DashboardBundle from '../../../../i18n/DashboardBundle.properties';
import compTraitUtil from './util/componentTraitUtil';
import logger from 'js-sdk/src/common/logging/logger';
import AdHocView from "bi-adhoc/src/bi/adhoc/AdHocView";
import hyperlinkTargets from "bi-report/src/bi/report/jive/enum/hyperlinkTargets";

const i18n = Object.assign({}, jasperserverMessages, DashboardBundle);
const log = logger.register("reportTrait");

/**
 * @memberof reportTrait
 * @access private
 * @desc initializes pagination, if report has two or more pages. If pagination already initialized, refreshes then.
 * @param {object} options
 * @param {object} options.resetCurrent - reset current page on refresh
 */

function initPagination(options){
    const self = this;

    // request export of 2 pages to know if pagination is needed. (array like func access due to IE8 issue)
    this.component && this.component["export"]({ outputFormat: "html", pages: 2 })
        .done(function() {
            const totalPages = self.component.data().totalPages;
            // pagination initialization with validation and event firing off. Needed in case of not fully loaded report so we can switch the pages in process of loading.
            if(!self.paginationView && totalPages !== 0 ){
                compTraitUtil._initPagination.call(self,{total: totalPages, silent: true, validate: false});
                // make next buttons available
                self.paginationView.$el.find(".next, .prev, .first").prop("disabled", false);
            }else{
                totalPages > 1 && self._refreshPagination(totalPages, options);
            }
        });
}
function createAdhocReportInstance(resourceUri, params) {
    return (new Report({
        resource: resourceUri,
        params: params,
        server: dashboardSettings.CONTEXT_PATH ? dashboardSettings.CONTEXT_PATH : window.location.origin,
    }));
}

function exportReport(self, options, Notification, i18n, loading) {
    self.reportComponent["export"](options).done(function (result) {
        window.open(result.href);
    }).fail(function () {
        Notification.show({
            message: i18n["dashboard.dashlet.error.report.export.failed"]
        });
    }).always(function () {
        loading.close();
        loading.remove();
    });
}
function signalHandler(payload){
    if (payload.name === dashboardWiringStandardIds.REFRESH_SLOT) {
        if (this.paramsModel.paramsChanged) {
            this.paramsModel.paramsChanged = false;
            this.component.params(compTraitUtil.extractExecutionParams.call(this));
        }
        this.refresh();
    } else if (payload.name === dashboardWiringStandardIds.APPLY_SLOT) {
        if (this.paramsModel.paramsChanged  && this.model.get('dashletHyperlinkTarget') !== hyperlinkTargets.BLANK) {
            if (this.component) {
                if (this.paramsModel._current === -1 && this.model.get('type') === "reportOptions") {
                    this.component.params(this.model.get('reportOptionParams'));
                } else {
                    this.component.params(compTraitUtil.extractExecutionParams.call(this));
                }
            }
            if(this.paginationView){
                this.paginationView.resetSetOptions({silent: true,validate: false});
                this.paginationView.model.set(this.paginationView.model.defaults);
                this.paginationView.$el.find(".next, .prev, .first").prop("disabled", false);
            }
            this.paramsModel._current === -1 && this.model.get('dashletHyperlinkTarget') === dashboardSettings.DASHLET_REPLACE_ACTION && this.model.set('isReplacedHyperlink', false);
            let parameters = compTraitUtil.extractExecutionParams.call(this);
            if (parameters.target !== dashboardSettings.DASHLET_REPLACE_ACTION) {
                this.replaceComponent && compTraitUtil.destroyReplaceComponent.call(this);
                if (!this.component) {
                    this.model.getReportResourceUri().done((uri, error) => {
                        if (error) {
                            this._broken = true;
                            compTraitUtil.onReportFailedRun.call(this, error);
                        } else {
                            let isReportOption = this.model.get('type') === "reportOptions",
                                url = isReportOption ? this.model.get('reportOptionParent') : uri,
                                parameters = isReportOption ? this.model.get('reportOptionParams') : {},
                                pages;
                            this.component = compTraitUtil.createReportInstance.call(this, url, parameters, pages, destroyDrilldownComponent)
                            compTraitUtil.updateReportLinkOptions.call(this);
                        }
                    });
                }
                this.component.params(parameters);
            }
            this.paramsModel.paramsChanged = false;
            this.isReportRan = false;
            this.refresh();
        }
    }
}

function destroyDrilldownComponent() {
    if (this.drilldownComponent) {
        this.drilldownComponent instanceof WebPageView ? this.drilldownComponent.remove() : this.drilldownComponent.destroy();
        this.drilldownComponent = null;
    }
}

function extractReportHyperlinks() {
    const links = this.component.data()?.links;
    const hyperlinkValues = [], outputParameters = [];
    links && links.forEach(obj => {
        obj.parameters && Object.keys(obj.parameters).forEach(value => {
            if (obj.type=== hyperlinkTypes.REPORT_DASHLET_EXECUTION && !hyperlinkValues.includes(value)) {
                hyperlinkValues.push(value);
            }
        })
    })
    hyperlinkValues.forEach(value => {
        outputParameters.push({id: value, label: value, multipleValues: false, valueType: "java.lang.String"});
        this.model.set("isHyperlinkTypeDashlet", true);
    })
    links && this.model.set('outputParameters', outputParameters);
}

function onReportSuccessfulRun(triggerComponentRendered) {
    this.hideMessage();

    triggerComponentRendered !== false && this.trigger("componentRendered", this);
    compTraitUtil.enableBackButton.call(this);

    !compTraitUtil.isAdhocChartReport(this) && compTraitUtil._resetContentOverflow.call(this, compTraitUtil._calculateContentOverflow.call(this));
    this.component && extractReportHyperlinks.call(this);
    toggleVizIcon.call(this);
    this.$el.find('.jrPage .highcharts_parent_container').attr("js-stdnav", "false");

    const isEmpty = !compTraitUtil.findJrPageTable(this.$content);

    isEmpty && this.showMessage({ errorCode: "report.empty.error" });

    const component = this.drilldownComponent && this.drilldownComponent instanceof Report ? this.drilldownComponent : this.component;
    this.model.reportExecutionId = component?._getExecutionId();
}

function toggleVizIcon() {
    let showVizSelector = false;
    if (this.model.get('showVizSelectorIcon') !== undefined && this.$el && this.$el.find('.jive_chartSettingsIcon').length) {
        showVizSelector = true;
        this.model.get('showVizSelectorIcon') ? this.$('> .dashletContent > .content').removeClass("hideVizLauncher") : this.$('> .dashletContent > .content').addClass("hideVizLauncher");
    }
    this.model.set('showVizSelector', showVizSelector);
}

function changeReportPages(component, pages) {
    if (!_.isUndefined(pages)) {
        component.pages(pages).run()
            .done(_.bind(onReportSuccessfulRun, this))
            .fail(_.bind(compTraitUtil.onReportFailedRun, this));
    }
}

function buildOutputUrl(resource, output, pages, params) {
    const queryParams = _.extend({}, params),
        template = _.template("{{= contextPath }}/rest_v2/reports{{= resource }}.{{= output }}{{= params }}");

    !_.isUndefined(pages.pages) && (queryParams.pages = pages.pages);
    !_.isUndefined(pages.anchor) && (queryParams.anchor = pages.anchor);

    if (output === "xlsNoPag") {
        queryParams.ignorePagination = true;
        output = "xls";
    }

    if (output === "xlsxNoPag") {
        queryParams.ignorePagination = true;
        output = "xlsx";
    }

    return template({
        contextPath: dashboardSettings.CONTEXT_PATH,
        resource: resource,
        output: output,
        params: !_.isEmpty(queryParams) ? ("?" + $.param(queryParams, true)) : ""
    });
}

function buildOutputExportOptions(output, pages) {
    const exportOptions = {
        outputFormat: output,
        pages: pages
    };

    if (output === "xlsNoPag") {
        exportOptions.outputFormat = "xls";
    }

    if (output === "xlsxNoPag") {
        exportOptions.outputFormat = "xlsx";
    }

    return exportOptions;
}

/**
 * Factory to format error messages depending on error code
 */
const reportErrorMessageFactory = (function () {
    const errorMessageFormatters = {};

    errorMessageFormatters["dashboard.dashlet.error.input.controls.validation.error"] = function (messageObj) {
        return i18n["dashboard.dashlet.error." + messageObj.errorCode];
    };

    return function (messageObj) {
        const formatter = errorMessageFormatters[messageObj.errorCode];

        return formatter
            ? formatter(messageObj)
            : (i18n["dashboard.dashlet.error." + messageObj.errorCode] || i18n["dashboard.dashlet.error.unexpected.error"]);
    };
})();

export default {

    _onViewInitialize: function() {
        this.$el.addClass("dashboardVisualization");

        this.listenTo(this.model, "signal", _.bind(signalHandler, this));

        if (this.model.lastPayload) {
            for (const key in this.model.lastPayload){
                signalHandler.call(this, {name: key, value: this.model.lastPayload[key]}, this.model.lastSender[key]);
            }
        }
    },

    updateReportSettings: function() {
        this.component && this.component.properties(sandboxFactory.get(this.dashboardId).get("reportSettings") || {});
        this.drilldownComponent && this.drilldownComponent instanceof Report
        && this.drilldownComponent.properties(sandboxFactory.get(this.dashboardId).get("reportSettings") || {});
    },

    exportAs: function (options) {
        const component = this.drilldownComponent && this.drilldownComponent instanceof Report ? this.drilldownComponent : this.component ? this.component : this.replaceComponent,
            loading = new LoadingDialog({cancellable: false});

        let chartComponent, self = this,
            dashletHyperlinkType = this.model.get('dashletHyperlinkType'),
            runReportComponent = function () {
                this.reportComponent.run().then(function () {
                    if ((self.updatedChartType && self.component) || (self.replaceChartType && self.replaceComponent)) {
                        chartComponent = self.reportComponent.data().components[0];

                        chartComponent.chartType = self.component ? self.updatedChartType : self.replaceChartType;

                        self.reportComponent.updateComponent(chartComponent).done(function () {
                            exportReport(self, options, Notification, i18n, loading);
                        });
                    } else {
                        exportReport(self, options, Notification, i18n, loading);
                    }
                });
            };
        loading.open();
        if (this.replaceComponent && dashletHyperlinkType === "adhocDataView") {
            this.reportComponent = createAdhocReportInstance.call(this, this.createReplaceReportUri, this.replaceComponent.params());
            runReportComponent.call(this);
        } else if (this.replaceComponent && (dashletHyperlinkType === "reportUnit" || dashletHyperlinkType === "reportOptions")) {
            this.reportComponent = this.replaceComponent;
            exportReport(self, options, Notification, i18n, loading);
        } else {
            this.reportComponent = component instanceof Report ? component :  createAdhocReportInstance.call(this, this.createReportUri, this.component.params());
            runReportComponent.call(this);
        }
    },

    /**
     * @memberof reportTrait
     * @access protected
     * @desc initializes report component specific behavior
     */

    _initComponent: function () {
        let self = this,
            pages;

        _.bindAll(this, "updateReportSettings");

        if (this.dashboardId) {
            const sandbox = sandboxFactory.get(this.dashboardId);
            sandbox.on("linkOptions", compTraitUtil.updateReportLinkOptions.bind(this));
            sandbox.on("reportSettings", this.updateReportSettings);
        }

        this.model.getReportResourceUri().done(function (uri, error) {
            if (error){
                self._broken = true;
                compTraitUtil.onReportFailedRun.call(self, error);
            } else {
                let isReportOption = self.model.get('type') === "reportOptions",
                    url = isReportOption ? self.model.get('reportOptionParent') : uri,
                    parameters = isReportOption ? self.model.get('reportOptionParams') : {} ;

                self.component = compTraitUtil.createReportInstance.call(self, url, parameters, pages, destroyDrilldownComponent);

                //set linkOptions manually first time
                compTraitUtil.updateReportLinkOptions.call(self);
            }
        });
    },

    /**
     * @memberof reportTrait
     * @access protected
     * @desc remove component, sign off all events remove sub components
     */

    _removeComponent: function (options) {
        const sessionExpired = options ? options.sessionExpired : false;
        !sessionExpired && this.isReportRan && this.component.destroy();
        this.component = null;
        destroyDrilldownComponent.call(this);
        this.isReportRan = false;

        if (this.dashboardId) {
            const sandbox = sandboxFactory.get(this.dashboardId);
            sandbox.off("linkOptions", compTraitUtil.updateReportLinkOptions.bind(this));
            sandbox.off("reportSettings", this.updateReportSettings);
        }

        this._removePagination();

        this.exportMenu && this.exportMenu.remove();
    },

    _renderComponent: function () {
        if (this.drilldownComponent && this.drilldownComponent instanceof WebPageView) {
            if (this.paginationView) {
                this.paginationView.hide();
                this.resizeContentContainer();
            }

            this.drilldownComponent.render(this.$content);
            this.trigger("componentRendered", this);
        } else if (this.drilldownComponent && this.drilldownComponent instanceof Report) {
            this.drilldownComponent.render(_.bind(this.trigger, this, "componentRendered", this));
            !compTraitUtil.isAdhocChartReport(this) && compTraitUtil._resetContentOverflow.call(this, compTraitUtil._calculateContentOverflow.call(this));
        } else {
            // usually initial run triggered after wiring is initialized and initial parameters for reports are set
            if (this.isReportRan) {
                this.component.render(_.bind(this.trigger, this, "componentRendered", this));
                !compTraitUtil.isAdhocChartReport(this) && compTraitUtil._resetContentOverflow.call(this, compTraitUtil._calculateContentOverflow.call(this));
            }
        }

        if (this.toolbar) {
            const self = this;
            //TODO: remove object with 'menuContainerTemplate' and 'menuOptionTemplate' when designing new JS component
            // required fix for JRS-10104
            this.exportMenu = new HoverMenu(compTraitUtil.exportOptions, this.toolbar.getOptionView('export').$el, null, {
                menuContainerTemplate: menuContainerTemplate,
                menuOptionTemplate: menuOptionTemplate
            });

            _.each(compTraitUtil.exportOptions, function(option){
                self.listenTo(self.exportMenu, "option:" + option.action, function(){
                    self.exportMenu.hide();
                    self.exportAs(option.params);
                });
            });
        }
    },

    _resizeComponent: function () {
        if (this.drilldownComponent) {
            if (this.drilldownComponent instanceof Report) {
                if (this.isReportRan) {
                    this.drilldownComponent.resize();
                    !compTraitUtil.isAdhocChartReport(this) && compTraitUtil._resetContentOverflow.call(this, compTraitUtil._calculateContentOverflow.call(this));
                }
            }
            // we do nothing when we have active web page drilldown
        } else if (this.replaceComponent) {
            if (this.replaceComponent instanceof AdHocView) {
                this.replaceComponent.resize();
                compTraitUtil._resetContentOverflow.call(this, compTraitUtil._calculateContentOverflow.call(this));
            } else if (this.replaceComponent instanceof Report) {
                this.replaceComponent.resize();
                !compTraitUtil.isAdhocChartReport(this) && compTraitUtil._resetContentOverflow.call(this, compTraitUtil._calculateContentOverflow.call(this));
            }
        } else if (this.component && this.isReportRan) {
            this.component.resize();
            !compTraitUtil.isAdhocChartReport(this) && compTraitUtil._resetContentOverflow.call(this, compTraitUtil._calculateContentOverflow.call(this));
        }
    },

    notify: function(parameters, url, target, hasParamGrammer){
        const signals = _.reduce(this.model.get("outputParameters"), function (memo, param) {
            const value = parameters[param.id];
            if (value) {
                memo || (memo = {});
                memo[param.id] = _.isArray(value) ? value : [value];
            }
            return memo;
        }, false);

        if (signals){
            _.each(this.model.get("outputParameters"), function(value, key, obj) {
                if(!signals[value.id]){
                    signals[value.id] = [];
                }
            });
            this.model.notify(signals);
            if( target === dashboardSettings.DASHLET_REPLACE_ACTION) {
                compTraitUtil.replaceParameterGrammer.call(this, url, target, hasParamGrammer);
            }
            this.model.collection.getDashboardPropertiesComponent().applyParameters();
        }
    },
    replace: function (replaceInfo) {
        let params = replaceInfo.parameters ? compTraitUtil.convertHyperlinksParamsToVizJsApi(replaceInfo.parameters) : undefined,
            pages,
            self = this;
        this.isReportRan = false;
        this.updatedChartType = null;
        this.model.updatedChartType = null;
        compTraitUtil.destroyReplaceComponent.call(this);
        this.paginationView && this.paginationView.hide();
        this.paginationView && this.resizeContentContainer();
        this.model.get('dashletHyperlinkLabel') && this.$dashlet.find('.dashletToolbar.toolbar .header .labelWrapper p').html(this.model.get('dashletHyperlinkLabel'));
        this.model.set('isReplacedHyperlink', true);
        if(this.model.get('showBackButton')){
            this.toolbar.$el.find('.hyperlinkBackbutton').parent().addClass('hyperlink');
            this.toolbar.$el.find('.hyperlink').css('display','block');
        }
        let hyperlinkType = this.model.get('dashletHyperlinkType');
        if (hyperlinkType === "reportUnit") {
            this.replaceComponent = compTraitUtil.createReportInstance.call(this, replaceInfo.resource, params, pages, compTraitUtil.destroyReplaceComponent);
            compTraitUtil.updateReportLinkOptions.call(this);
            this.replaceComponent.run().done(_.bind(onReportSuccessfulRun, this)).fail(_.bind(compTraitUtil.onReportFailedRun, this));
        } else if (hyperlinkType === "adhocDataView") {
            this.model.componentInitializedDfd = new $.Deferred();
            this.model.getReplacedAdhocResourceUri(replaceInfo.resource).done(function (uri, adhocUri, error) {
                if (error) {
                    self._broken = true;
                    compTraitUtil.onAdhocFailedRun.call(self, error);
                } else {
                    self.createReplaceReportUri = uri;
                }
            });
            this.replaceComponent = compTraitUtil.createAdhocViewInstance.call(this, replaceInfo.resource, params);
            compTraitUtil.updateAdhocLinkOptions.call(self);
            this.replaceComponent.run().done(_.bind(compTraitUtil.onAdhocSuccessfulRun, this, false, toggleVizIcon)).fail(_.bind(compTraitUtil.onAdhocFailedRun, this));
        } else if (hyperlinkType === "reportOptions") {
            params = Object.keys(params).length === 0  ? self.model.get("dashletHyperlinkReportOptionParam") : params;
            this.replaceComponent = compTraitUtil.createReportInstance.call(this, self.model.get("dashletHyperlinkReportOption"), params, pages, compTraitUtil.destroyReplaceComponent);
            compTraitUtil.updateReportLinkOptions.call(this);
            this.replaceComponent.run().done(_.bind(onReportSuccessfulRun, this)).fail(_.bind(compTraitUtil.onReportFailedRun, this));
        }
    },

    drilldown: function(drilldownInfo) {
        let params = drilldownInfo.parameters ? compTraitUtil.convertHyperlinksParamsToVizJsApi(drilldownInfo.parameters) : undefined,
            output = drilldownInfo.parameters && !_.isUndefined(drilldownInfo.parameters._output) ? drilldownInfo.parameters._output : undefined,
            pages,
            self = this;

        if (!_.isUndefined(drilldownInfo.pages)) {
            pages = {
                pages: drilldownInfo.pages
            }
        }

        if (!_.isUndefined(drilldownInfo.anchor)) {
            pages = _.extend({
                anchor: drilldownInfo.anchor
            }, pages);
        }

        if (drilldownInfo.type === hyperlinkTypes.REFERENCE) {
            destroyDrilldownComponent.call(this);

            // URLs can contain javascript functions. Ignore them in this case
            if (drilldownInfo.href.indexOf("javascript:") > -1) {
                return;
            } else {
                this.drilldownComponent = new WebPageView({url: drilldownInfo.href});

                this.render();
            }
        } else if (drilldownInfo.type === hyperlinkTypes.REPORT_EXECUTION) {
            if (!_.isUndefined(output) && output !== reportOutputFormats.HTML) {
                // iOS doesn't support downloading files. So instead we open a new browser tab with file to give user
                // ability to decide what to do with this file.
                // To open a new tab, we emulate click on <a href="...">. We cannot wait for Viz.js export, so we
                // are using rest_v2/reports service here.
                if (_.isUndefined(pages)){
                    pages = {};
                }

                if (browserDetection.isIOS()) {
                    const a = document.createElement('a');
                    a.setAttribute("href", buildOutputUrl(drilldownInfo.resource, output, pages, params));
                    a.setAttribute("target", "_blank");
                    a.setAttribute("rel", "noopener noreferrer")

                    const dispatch = document.createEvent("HTMLEvents");
                    dispatch.initEvent("click", true, true);
                    a.dispatchEvent(dispatch);
                } else {
                    const exportOptions = buildOutputExportOptions(output, pages),
                        report = new Report({
                            resource: drilldownInfo.resource,
                            params: params,
                            server: dashboardSettings.CONTEXT_PATH,
                            showAdhocChartTitle: true,
                            ignorePagination: output === "xlsNoPag" || output === "xlsxNoPag",
                            pages: _.isUndefined(pages.pages) && _.isUndefined(pages.anchor) ? 1 : pages
                        });

                    report
                        .run()
                        .done(function() {
                            report["export"](exportOptions)
                                .done(function(link) {
                                    const url = link.href || link;

                                    if (self.dashboardId && sandboxFactory.get(self.dashboardId).get("previewMode")) {
                                        sandboxFactory.get(self.dashboardId).set("disablePageLeaveConfirmation", true);
                                    }

                                    window.location.href = url;

                                    if (self.dashboardId && sandboxFactory.get(self.dashboardId).get("previewMode")) {
                                        _.defer(function () {
                                            sandboxFactory.get(self.dashboardId).set("disablePageLeaveConfirmation", false);
                                        });
                                    }
                                });
                        });
                }
            } else {
                if (drilldownInfo.resource === this.component.resource()) {
                    destroyDrilldownComponent.call(this);

                    if (params) {
                        this.component.params(params);

                        this.refresh()
                            .done(_.bind(changeReportPages, this, this.component, pages));
                    } else {
                        changeReportPages.call(this, this.component, pages);
                    }
                } else if (this.drilldownComponent && this.drilldownComponent instanceof Report && drilldownInfo.resource === this.drilldownComponent.resource()) {
                    if (params) {
                        this.drilldownComponent.params(params).refresh()
                            .done(_.bind(changeReportPages, this, this.drilldownComponent, pages))
                            .fail(_.bind(compTraitUtil.onReportFailedRun, this));
                    } else {
                        changeReportPages.call(this, this.drilldownComponent, pages);
                    }
                } else {
                    destroyDrilldownComponent.call(this);

                    this.paginationView && this.paginationView.hide();
                    this.paginationView && this.resizeContentContainer();

                    this.drilldownComponent = compTraitUtil.createReportInstance.call(this, drilldownInfo.resource, params,  pages, destroyDrilldownComponent);

                    compTraitUtil.updateReportLinkOptions.call(this);

                    this.drilldownComponent.run()
                        .done(_.bind(onReportSuccessfulRun, this))
                        .fail(_.bind(compTraitUtil.onReportFailedRun, this));
                }
            }
        }
    },

    refresh: function () {
        compTraitUtil.updateToolbarBackButton.call(this);

        let self = this,
            res = new $.Deferred(),
            dfd =  this.paramsModel.paramsChanged ? (new $.Deferred()).resolve() : this.cancel();

        dfd.always(function() {
            if (self.isReportRan) {
                self.ready.done(function() {
                    self.isReportRunning = true;

                    destroyDrilldownComponent.call(self);

                    self.component
                        .refresh()
                        .fail(res.reject)
                        .done(function () {
                            let options = self.isPageChangingWhileReportIsRunning || {resetCurrent: true};
                            initPagination.call(self, options);
                            onReportSuccessfulRun.call(self, false);
                            compTraitUtil.isDashletSelect.call(self) && self.$el.trigger('click');
                            res.resolve();

                            self.isPageChangingWhileReportIsRunning = false;
                        });
                });
            } else {
                let parameters = compTraitUtil.extractExecutionParams.call(self);
                if (parameters.target === dashboardSettings.DASHLET_REPLACE_ACTION && !self.model.get('isReplacedHyperlink')) {
                    self.component && self._removeComponent();
                    self.replace(parameters);
                    if (self.toolbar) {
                        self.model.get('showExportButton') && self.toolbar.getOptionView("export").enable();
                        //TODO: remove object with 'menuContainerTemplate' and 'menuOptionTemplate' when designing new JS component
                        self.exportMenu = new HoverMenu(compTraitUtil.exportOptions, self.toolbar.getOptionView('export').$el, null, {
                            menuContainerTemplate: menuContainerTemplate,
                            menuOptionTemplate: menuOptionTemplate
                        });

                        _.each(compTraitUtil.exportOptions, function(option){
                            self.listenTo(self.exportMenu, "option:" + option.action, function(){
                                self.exportMenu.hide();
                                self.exportAs(option.params);
                            });
                        });
                    }
                } else if (self.component && parameters.target !== dashboardSettings.DASHLET_REPLACE_ACTION) {
                    // in some cases, like Undo All, component may not exist at this time, so need additional checks
                    self.isReportRunning = true;
                    self.component
                        .run()
                        .fail(res.reject)
                        .done(function () {
                            self.isReportRan = true;
                            initPagination.call(self);
                            self.resizeContentContainer();
                            onReportSuccessfulRun.call(self);
                            compTraitUtil.isDashletSelect.call(self) && self.$el.trigger('click');
                            res.resolve();
                        });
                } else if (self.replaceComponent && parameters.target === dashboardSettings.DASHLET_REPLACE_ACTION) {
                    self.replaceComponent
                        .run()
                        .fail(res.reject)
                        .done(function () {
                            self.replaceComponent instanceof Report ? onReportSuccessfulRun.call(self): compTraitUtil.onAdhocSuccessfulRun.call(self, false, toggleVizIcon);
                            res.resolve();
                        });
                } else {
                    self._broken || self.hideMessage();
                    res.resolve();
                }
            }
        });

        res
            .fail(_.bind(compTraitUtil.onReportFailedRun, this))
            .always(_.bind(this._onReportRunFinished, this));

        return res;
    },

    cancel: function () {
        return this.isReportRunning && this.component
            ? this.component.cancel()
            : (new $.Deferred()).resolve();
    },

    back: compTraitUtil.back,

    /**
     * @memberof reportTrait
     * @access protected
     * @param {number} totalPages - set total pages
     * @param {object} options
     * @param {boolean} [options.resetCurrent] - reset or not current page
     * @desc Refreshes pagination.
     */

    _refreshPagination: function (totalPages, options) {
        const setOptions = {
            "total": totalPages
        };

        if(options && options.resetCurrent){
            setOptions.current = this.paginationView.model.defaults.current
        }
        // returns pagination validation into default state
        this.paginationView.resetSetOptions();
        this.paginationView.model.set(setOptions);
        this.model.get("showPaginationControl") && this.paginationView.show();
    },

    /**
     * @memberof reportTrait
     * @access protected
     * @desc Removes pagination.
     */

    _removePagination: function () {
        if (this.paginationView) {
            this.stopListening(this.paginationView);
            this.paginationView.remove();
            this.paginationView = null;
        }
    },


    /**
     * @memberof reportTrait
     * @access protected
     * @desc on component rendered event handler. If report is a chart, then scale stategy sets to container. Else content overflow is being calculated.
     */

    _onComponentRendered: function(){
        this.model.set("isAdhocChart", compTraitUtil.isAdhocChartReport(this));
    },

    _onReportRunFinished: function () {
        this.isReportRunning = false;
        this.$el.addClass("rendered");
        this.toolbar && this.toolbar.getOptionView("export").enable();
    },

    /**
     * @memberof reportTrait
     * @access protected
     * @desc on component properties change event handler. Triggers after some properties were changed through properties dialog.
     */

    _onComponentPropertiesChange: function () {
        // Re-render report only when visual props have changed
        if (this.model.hasChanged("scaleToFit")) {
            this.component.scale(this.model.get("scaleToFit"));
            this._renderComponent();

            compTraitUtil._resetContentOverflow.call(this, compTraitUtil._calculateContentOverflow.call(this));
        }

        if (this.model.hasChanged("showPaginationControl") && this.paginationView) {
            if (this.model.get("showPaginationControl") && this.paginationView.model.get("total") > 1) {
                this.paginationView.show();
                this.resizeContentContainer();
            } else if (!this.model.get("showPaginationControl")) {
                this.paginationView.hide();
                this.resizeContentContainer();
            }
        }
    },

    _errorMessageFactory: reportErrorMessageFactory
}
